import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

export interface DlgProgressData {
  message: string;
}

@Component({
  selector: 'app-dlg-progress',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './dlg-progress.component.html',
  styleUrl: './dlg-progress.component.css',
})
export class DlgProgressComponent {
  readonly dialogRef = inject(MatDialogRef<DlgProgressComponent>);
  private readonly data = inject<DlgProgressData>(MAT_DIALOG_DATA);

  message: string = 'Working in background...';

  constructor() {
    if (this.data && this.data.message) {
      this.message = this.data.message;
    }
  }
}
